module.exports = __webpack_public_path__ + "img/feixinjiaju6.6d494afc.jpg";